import tw, { styled } from 'twin.macro';
import chroma from 'chroma-js';

import Explainer from '../../Explainer';

const MarkdownBlockQuote = styled(Explainer)`
  ${tw`my-4`}
  & strong:first-child {
    ${tw`mb-2 uppercase text-xs tracking-wide`}
  }

  .message-type-markdown & {
    ${tw`m-0`}
    padding-left: 0.5rem;
    padding-right: 0.5rem;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    margin-top: 0.5rem;
  }

  .message-type-markdown-left & {
    background: ${({ theme }) => chroma(theme.primary).alpha(0.1)};
  }
`;

export default MarkdownBlockQuote;
